"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillTwoDimensionalArray = exports.createTwoDimensionalArray = exports.isNullOrUndefined = void 0;
function isNullOrUndefined(v) {
    return v === null || v === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
function createTwoDimensionalArray(d1, d2) {
    var array = Array(d1);
    for (var i = 0; i < array.length; i++) {
        array[i] = Array(d2);
    }
    return array;
}
exports.createTwoDimensionalArray = createTwoDimensionalArray;
function fillTwoDimensionalArray(arr, value) {
    if (value === void 0) { value = 0; }
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var row = arr_1[_i];
        for (var i = 0; i < row.length; i++) {
            row[i] = value;
        }
    }
}
exports.fillTwoDimensionalArray = fillTwoDimensionalArray;
